import {httpClient} from "../funcs"

export const API_REACHABILITY_TIMEOUT_MS = 5000

/**
 * Проверяет, доступен ли API с устройства пользователя.
 * Любой HTTP-ответ (включая 4xx/5xx) = сеть до API есть.
 * Только сетевой обрыв / таймаут = недоступен.
 */
export async function checkApiReachable(
    timeoutMs: number = API_REACHABILITY_TIMEOUT_MS
): Promise<boolean> {
    try {
        await httpClient.get("/verification-code/disabled-channels", {
            timeout: timeoutMs,
            validateStatus: () => true,
        })
        return true
    } catch {
        return false
    }
}
